import { CaseType } from 'src/app/models/enums/case-type';
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { Branch } from "src/app/models/branch/branch";
import { Case } from "src/app/models/case/case";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { CaseService } from "src/app/services/case.service";

interface CaseBankGroup {
  bankName: string;
  cases: Case[];
  navId: number;
  activeCaseId: number;
}

@Component({
  selector: "app-case-index",
  templateUrl: "./case-index.component.html",
  styleUrls: ["./case-index.component.scss"],
  providers: [],
})
export class CaseIndexComponent extends BaseComponent implements OnInit {
  breadCrumbItems: Array<{}> = [
    { label: "Kasa Bakiyeleri" },
    { label: "Kasa", active: true },
  ];
  activeCase: number = 1;
  branch: Branch = JSON.parse(localStorage.getItem("currentBranch"));
  caseSubscription: Subscription;
  caseList: Case[] = [];
  normalCases: Case[] = [];
  bankGroups: CaseBankGroup[] = [];

  constructor(
    private caseService: CaseService,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.loadCaseList();
    this.caseSubscription = this.caseService.refreshIndex.subscribe(() => {
      this.loadCaseList();
    });
  }

  ngOnDestroy() {
    this.caseSubscription.unsubscribe();
  }

  loadCaseList() {
    this.caseService
      .getAllWoutPaging({
        branchId: this.branch.id,
      })
      .toPromise()
      .then((res) => {
        this.caseList = res.data.Items;
        this.groupCases();
        this.selectInitialCase();
      });
  }

  readonly CaseType = CaseType;

  groupCases() {
    this.normalCases = this.caseList.filter((c) => !c.hasBankAccount);

    const map = new Map<string, Case[]>();
    this.caseList
      .filter((c) => c.hasBankAccount)
      .forEach((c) => {
        const bankName = c.bankName || 'Diğer';
        if (!map.has(bankName)) {
          map.set(bankName, []);
        }
        map.get(bankName).push(c);
      });

    let index = 0;
    this.bankGroups = Array.from(map.entries()).map(([bankName, cases]) => {
      index++;
      return { bankName, cases, navId: -(index + 1), activeCaseId: cases[0]?.id };
    });
  }

  selectInitialCase() {
    if (this.caseList.length === 0) {
      return;
    }

    const queryCaseId = Number(this.route.snapshot.queryParams['caseId']);
    const requestedCase = queryCaseId && this.caseList.find((c) => c.id === queryCaseId);

    if (requestedCase && requestedCase.hasBankAccount) {
      const group = this.bankGroups.find((g) => g.bankName === (requestedCase.bankName || 'Diğer'));
      if (group) {
        this.activeCase = group.navId;
        group.activeCaseId = requestedCase.id;
        return;
      }
    }

    if (requestedCase) {
      this.activeCase = requestedCase.id;
      return;
    }

    if (this.normalCases.length > 0) {
      this.activeCase = this.normalCases[0].id;
    } else if (this.bankGroups.length > 0) {
      this.activeCase = this.bankGroups[0].navId;
    }
  }
}
